import { append, filter, not, equals, compose, curry, path } from 'ramda'

const notEquals = curry((a, b) => compose(not, equals(a))(b))

export default {
  /**
   * Sets the loaded value.
   *
   * @param {Object} state
   * @param {boolean} loaded
   */
  SET_LOADED(state, { loaded }) {
    state.loaded = loaded
  },

  /**
   * Replaces the entities in the state.
   *
   * @param {Object} state
   * @param {Array} entities
   */
  REPLACE_ENTITIES(state, { entities }) {
    state.entities = entities
  },

  /**
   * Adds an entity ID to the viewed entity ID list.
   *
   * @param {Object} state
   * @param {Number} entityId
   */
  ADD_VIEWED_ENTITY_ID(state, { entityId }) {
    state.viewedEntityIds = append(entityId, state.viewedEntityIds)
  },

  /**
   * Removes an entity from the state.
   *
   * @param {Object} state
   * @param {Object} entity
   */
  REMOVE_ENTITY(state, { entity }) {
    state.entities = filter(
      compose(
        notEquals(path(['id'], entity)),
        path(['id']),
      ),
      state.entities,
    )
  },
}
